import { apiClient, clearCsrfToken } from './client'
import type { User } from './types'

export async function login(email: string, password: string): Promise<User> {
  const { data } = await apiClient.post<User>('/auth/login', { email, password })
  return data
}

export async function logout(): Promise<void> {
  try {
    await apiClient.post('/auth/logout')
  } finally {
    clearCsrfToken()
  }
}

/**
 * Returns the currently authenticated user, e.g. from a session cookie.
 * Called once on startup to restore the session (see `App.tsx`).
 */
export async function fetchCurrentUser(): Promise<User> {
  const { data } = await apiClient.get<unknown>('/auth/me')

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error('Invalid user response shape')
  }

  return data as User
}
